var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46175 5.34252C5.46175 5.34252 3.61842 5.54668 2.38875 5.68318C2.27792 5.6966 2.17992 5.77068 2.14317 5.88327C2.10642 5.99585 2.14317 6.1131 2.22484 6.18718C3.13834 7.02077 4.51092 8.2691 4.51092 8.2691C4.50975 8.2691 4.13409 10.085 3.88442 11.2966C3.86342 11.4063 3.90309 11.5223 3.99875 11.5918C4.09384 11.6612 4.21634 11.6623 4.31259 11.6081C5.38825 10.9968 6.99942 10.0774 6.99942 10.0774C6.99942 10.0774 8.61117 10.9968 9.68509 11.6087C9.78309 11.6623 9.90559 11.6612 10.0007 11.5918C10.0963 11.5223 10.136 11.4063 10.1144 11.2972C9.86475 10.085 9.48967 8.2691 9.48967 8.2691C9.48967 8.2691 10.8623 7.02077 11.7758 6.18893C11.8574 6.11252 11.8936 5.99527 11.8574 5.88327C11.8213 5.77127 11.7233 5.69718 11.6124 5.68435C10.3828 5.54668 8.53884 5.34252 8.53884 5.34252C8.53884 5.34252 7.77467 3.65202 7.26542 2.52502C7.21759 2.4241 7.11725 2.35352 6.99942 2.35352C6.88159 2.35352 6.78067 2.42468 6.73517 2.52502C6.22534 3.65202 5.46175 5.34252 5.46175 5.34252Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteStar);
export default __webpack_public_path__ + "static/media/vote-star.a29c7dbd088c87423379da5de47d36c1.svg";
export { ForwardRef as ReactComponent };